module.exports = __webpack_public_path__ + "img/clear-input.a89e198a.svg";